<template>
	<div class="email-preferences-view">

		<div class="email-preferences-view__header">
			<h2 class="common__heading bottom-gap-lg">Communication Preferences</h2>

      <div class="text--right">

        <router-link
          class="btn btn--secondary btn--sm bottom-gap-sm"
          :to="{name: 'onBoarding'}"
          v-show="hasUsername"
        >Update Preferences</router-link>
      </div>
    </div>

		<h3 class="common__sub-heading bottom-gap-lg">Receive communications from:</h3>

		<div class="email-preferences-view__container">

			<div
				v-for="(optOutCheckbox, index) in optOutCheckboxes"
				:key="'optOut'+index"
				:class="[
					'email-preferences-view__item',
					'email-preferences-view__item--full-width'
				]"
				v-if="optOutCheckbox.isChecked"
			>
				<checkbox
					:checkbox="optOutCheckbox"
					:showDescription="false"
					class="not-clickable"
				></checkbox>
			</div>

			<div
				v-for="(checkbox, index) in combinedCheckboxes"
				:key="index"
				:class="['email-preferences-view__item']"
				v-show="checkbox.isShow"
			>
				<checkbox
					:checkbox="checkbox"
					:showDescription="false"
					class="not-clickable"
				></checkbox>
			</div>

		</div>

	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import Checkbox from '../formFields/Checkbox.vue';

	export default {
    components: {
      Checkbox
    },
    props: {
      allCheckboxes: Array,
      onboardingCheckboxes: Object,
      user: {
        type: Object
      }
    },
    data() {
      return {
        hasUsername: false
      }
    },
    computed: {
      combinedCheckboxes() {
        return [].concat(...this.allCheckboxes);
      },
      optOutCheckboxes() {
        return this.onboardingCheckboxes.formGroups.disableCommunicationGroup.checkboxes;
      }
    },
    mounted() {
      if (this.user && this.user.username) this.hasUsername = true;
    }
  };
</script>

<style lang="scss" scoped>
	@import '~sass/_variables.scss';
	@import "~sass/_config.scss";
	@import "~sass/mixins/_media-query.scss";
	@import "~sass/mixins/_attr-bp.scss";

	$columnsFlexBasis: (
		default : 100%,
		tablet: 33.3333%
	);

	$bottomPadding: (
		default: 30px
	);

	.email-preferences-view {
    @include attr-bp($bottomPadding, 'padding-bottom');

    position: relative;

    &__container {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin-right: -15px;
      margin-bottom: -15px;
      padding-bottom: 25px;

      &:last-of-type {
        padding-bottom: 0;
      }
    }

    &__item {
      @include attr-bp($columnsFlexBasis, 'flex-basis');
      @include attr-bp($columnsFlexBasis, 'max-width'); // IE fix

      padding-right: 15px;
      margin-bottom: 25px;
      flex-grow: 0;
      flex-shrink: 0;

      &--full-width {
        flex-basis: 100%;
        max-width: 100%; // IE fix
      }
    }

    &::after {
      content: '';
      position: absolute;
      height: 0;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: $col-neutral--0;
      opacity: 0;
      transition: opacity $ttime;
    }

    &.is-disabled {
      pointer-events: none;

      &::after {
        height: initial;
        opacity: 0.6;
      }
    }

    @include mq(largeTablet) {
      &__header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
      }
    }
  }
</style>